import LocaleManager from '../utils/LocaleManager.js';
import Config from '../utils/Config.js';
import Utils from '../utils/Utils.js';

export default class WinPanel extends Phaser.Group {
    constructor(game)
    {
        super(game);

        let bg = this._bg = new Phaser.Image(game, 0, 0, 'panels.win-bg');
        this.addChild(bg);

        let title = this._title = new Phaser.Text(game, 20, (bg.height >> 1) + 2, LocaleManager.getString('winPanelTitle'), {
            font: Config.DEFAULT_FONT,
            fontSize: 18,
            fontWeight: 'bold'
        });
        title.anchor.y = 0.5;
        this.addChild(title);

        let valueText = this._valueText = new Phaser.Text(game, bg.width - 15, (bg.height >> 1) + 2, '', {
            font: Config.DEFAULT_FONT,
            fontSize: 28,
            fontWeight: 'bold'
        });
        valueText.anchor.set(1, 0.5);
        this.addChild(valueText);

        this.value = 0;
    }

    set value(value)
    {
        this._value = value || 0;
        this._valueText.text = Utils.formatMoney(value);
    }

    get value()
    {
        return this._value || 0;
    }
}
